/*
 * Garde du mode maintenance.
 * Vérifie les paramètres publics au chargement : si le mode est activé et
 * que la visiteuse n'est pas dans l'espace admin, la page de pause remplace
 * le contenu. L'admin reste toujours accessible pour couper le mode.
 * En cas d'erreur réseau, le contenu normal est affiché (jamais bloquant).
 */

import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchPublicSettings } from "@/lib/api";
import { MaintenancePage } from "@/pages/MaintenancePage";

export const MaintenanceGate = ({ children }) => {
  const location = useLocation();
  const [maintenance, setMaintenance] = useState(null);
  const [logoUrl, setLogoUrl] = useState("");
  const [checking, setChecking] = useState(false);

  const check = useCallback(async () => {
    setChecking(true);
    try {
      const settings = await fetchPublicSettings();
      setMaintenance(settings.maintenance || { enabled: false });
      setLogoUrl(settings.logo_url || "");
    } catch (error) {
      // Jamais bloquant : en cas de doute, le site reste accessible.
      setMaintenance({ enabled: false });
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const isAdminRoute = location.pathname.startsWith("/admin");
  // La page statut reste visible pendant une pause : c'est sa raison d'etre.
  const isStatusRoute = location.pathname.startsWith("/statut");
  if (!isAdminRoute && !isStatusRoute && maintenance && maintenance.enabled) {
    return (
      <MaintenancePage
        message={maintenance.message}
        resumeAt={maintenance.resume_at}
        logoUrl={logoUrl}
        onRetry={check}
        checking={checking}
      />
    );
  }
  return children;
};
